var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blank-layout',[_c('div',{staticClass:"daily-puzzle__wrapper"},[_c('daily-puzzle',{staticClass:"section-puzzle__puzzle"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }